import { toIsoDate } from "@acto/taskpane/field-sales-2/components/primitives/Calendar";
import type { CalendarController } from "@acto/taskpane/field-sales-2/components/primitives/Calendar";

// The visible grid's first cell → last cell, as an ISO date range for the meetings query.
// A month grid includes the leading/trailing days of adjacent months, so the range covers them
// too (their meeting-dots must render); a single-week grid spans Mo→So of that week.
export function visibleRange(controller: Pick<CalendarController, "weeks">): {
  startDate: string;
  endDate: string;
} {
  const cells = controller.weeks.flat();
  const first = cells[0].date;
  const last = cells[cells.length - 1].date;
  return { startDate: toIsoDate(first), endDate: toIsoDate(last) };
}
